'use strict';
{
    var template =
        '<div tabindex="-1" ng-class="" class="tfPopover qty-picker popover" style="outline: none; width: 28em; max-width:none; !important;">\n' +
        '<div style="padding: 10px;">' +
        '<style>' +
        '.qty-picker * button {' +
        'width: 100%;' +
        '}' +
        '</style>' +
        '<table class="table table-no-border noMargin qty-picker">' +
        '<tr ng-if="userConfig.client">' +
        '<td colspan="7" class="info-sub"><span class="">to <span class="long bold">buy</span> enter <span class="long bold">positive</span> quantity</td>' +
        '</tr>' +
        '<tr ng-if="userConfig.client">' +
        '<td colspan="7" class="info-sub"><span class="">to <span class="text-red-1 bold">sell</span>, enter <span class="text-red-1 bold">negative</span> quantity</span></td>' +
        '</tr>' +
        '<tr>' +
        '<td colspan="3" class=""><button ng-click="isBuy = true" tabindex="-1" ng-class="{active : isBuy}" class="btn btn-default summary-green"><i class="icon-circle-plus"></i><span class="title">INCREASE QTY</span></button></div>' +
        '<td colspan="3" class=""><button ng-click="isBuy = false" tabindex="-1" ng-class="{active : !isBuy}" class="btn btn-default summary-red"><i class="icon-circle-minus"></i><span class="title">decrease QTY</span></button></div>' +
        '<td colspan="1" class=""><button ng-click="swap()" tabindex="-1" class="btn btn-default"><i class="icon-swap_horiz"></i><span class="title">reverse</span></button></td>' +
        '</tr>' +
        '<tr>' +
        '<td colspan="2" class=""><button ng-click="add(1)" tabindex="-1" class="btn btn-default">1</button></td>' +
        '<td colspan="2" class=""><button ng-click="add(5)" tabindex="-1" class="btn btn-default">5</button></td>' +
        '<td colspan="2" class=""><button ng-click="add(10)" tabindex="-1" class="btn btn-default">10</button></td>' +
        '<td colspan="1" class=""><button ng-click="add(1)" ng-mousedown="plus()" ng-mouseup="stop()" ng-mouseleave="stop()" tabindex="-1" class="btn btn-default summary-green" style="padding: 4px 3px 3px 3px"><i class="icon-exposure_plus_1" style="font-size: 21.5px;"></i><span class="number "></span></button></td>' +
        '</tr>' +
        '<tr>' +
        '<td colspan="2" class=""><button ng-click="add(20)" tabindex="-1" class="btn btn-default">20</button></td>' +
        '<td colspan="2" class=""><button ng-click="add(50)" tabindex="-1" class="btn btn-default">50</button></td>' +
        '<td colspan="2" class=""><button ng-click="add(100)" tabindex="-1" class="btn btn-default">100</button></td>' +
        '<td colspan="1" class=""><button ng-click="add(-1)" ng-mousedown="minus()" ng-mouseup="stop()" ng-mouseleave="stop()" tabindex="-1" class="btn btn-default summary-red" style="padding: 4px 3px 3px 3px"><i class="icon-exposure_minus_1" style="font-size: 21.5px;"></i><span class="number"></span></button></td>' +
        '</tr>' +
        '<tr>' +
        '<td colspan="6" class=""><button ng-click="clear()" tabindex="-1" class="btn btn-default"><strong>CLEAR</strong></button></td>' +
        '</tr>' +
        '</div>' +
        '</div>';

    var whatIfLotsTemplate =
        '<div tabindex="-1" ng-class="" class="tfPopover qty-picker what-if-picker popover" style="outline: none; width: 28em; max-width:none; !important;">\n' +
        '<div style="padding: 10px;">' +
        '<style>' +
        '.qty-picker * button {' +
        'width: 100%;' +
        '}' +
        '</style>' +
        '<table class="table table-no-border noMargin qty-picker">' +
        '<tr ng-if="userConfig.client">' +
        '<td colspan="7" class="info-sub"><span class="">to <span class="long bold">buy</span> enter <span class="long bold">positive</span> quantity</td>' +
        '</tr>' +
        '<tr ng-if="userConfig.client">' +
        '<td colspan="7" class="info-sub"><span class="">to <span class="text-red-1 bold">sell</span>, enter <span class="text-red-1 bold">negative</span> quantity</span></td>' +
        '</tr>' +
        '<tr>' +
        '<td colspan="3" class=""><button ng-click="isBuy = true" tabindex="-1" ng-class="{active : isBuy}" class="btn btn-default summary-green"><i class="icon-circle-plus"></i><span class="title">INCREASE QTY</span></button></div>' +
        '<td colspan="3" class=""><button ng-click="isBuy = false" tabindex="-1" ng-class="{active : !isBuy}" class="btn btn-default summary-red"><i class="icon-circle-minus"></i><span class="title">decrease QTY</span></button></div>' +
        '</tr>' +
        '<tr>' +
        '<td colspan="2" class=""><button ng-click="add(1)" tabindex="-1" class="btn btn-default">1</button></td>' +
        '<td colspan="2" class=""><button ng-click="add(5)" tabindex="-1" class="btn btn-default">5</button></td>' +
        '<td colspan="2" class=""><button ng-click="add(10)" tabindex="-1" class="btn btn-default">10</button></td>' +
        '</tr>' +
        '<tr>' +
        '<td colspan="2" class=""><button ng-click="add(20)" tabindex="-1" class="btn btn-default">20</button></td>' +
        '<td colspan="2" class=""><button ng-click="add(50)" tabindex="-1" class="btn btn-default">50</button></td>' +
        '<td colspan="2" class=""><button ng-click="add(100)" tabindex="-1" class="btn btn-default">100</button></td>' +
        '</tr>' +
        '<tr>' +
        '<td colspan="6" class=""><button ng-click="clear(1)" tabindex="-1" class="btn btn-default"><strong>CLEAR</strong></button></td>' +
        '</tr>' +
        '</div>' +
        '</div>';

    var strategyTemplate =
        '<div tabindex="-1" ng-class="" class="tfPopover qty-picker popover" style="outline: none; width: 20em; max-width:none; !important;">\n' +
        '<div style="padding: 10px;">' +
        '<style>' +
        '.qty-picker * button {' +
        'width: 100%;' +
        '}' +
        '</style>' +
        '<table class="table table-no-border noMargin qty-picker">' +
        '<tr>' +
        '<td colspan="1" class=""><button ng-click="set(1)" tabindex="-1" class="btn btn-default">1</button></td>' +
        '<td colspan="1" class=""><button ng-click="set(2)" tabindex="-1" class="btn btn-default">2</button></td>' +
        '<td colspan="1" class=""><button ng-click="set(3)" tabindex="-1" class="btn btn-default">3</button></td>' +
        '<td colspan="1" class=""><button ng-click="set(4)" tabindex="-1" class="btn btn-default">4</button></td>' +
        '</tr>' +
        '<tr>' +
        '<td colspan="1" class=""><button ng-click="set(-1)" tabindex="-1" class="btn btn-default">-1</button></td>' +
        '<td colspan="1" class=""><button ng-click="set(-2)" tabindex="-1" class="btn btn-default">-2</button></td>' +
        '<td colspan="1" class=""><button ng-click="set(-3)" tabindex="-1" class="btn btn-default">-3</button></td>' +
        '<td colspan="1" class=""><button ng-click="set(-4)" tabindex="-1" class="btn btn-default">-4</button></td>' +
        '</tr>' +
        '</div>' +
        '<div class="icSub paddingLeft8"><strong>Note:</strong> Maximum ratio for a TMC is 4:1</div>' +
        '</div>';

    var strategyLotsTemplate =
        '<div tabindex="-1" ng-class="" class="tfPopover qty-picker popover" style="outline: none; width: 20em; max-width:none; !important;">\n' +
        '<div style="padding: 10px;">' +
        '<style>' +
        '.qty-picker * button {' +
        'width: 100%;' +
        '}' +
        '</style>' +
        '<table class="table table-no-border noMargin qty-picker">' +
        '<tr>' +
        '<td colspan="1" class=""><button ng-click="add(1)" ng-mousedown="plus()" ng-mouseup="stop()" ng-mouseleave="stop()" tabindex="-1" class="btn btn-default summary-green" style="padding: 4px 3px 3px 3px"><i class="icon-exposure_plus_1" style="font-size: 21.5px;"></i><span class="number "></span></button></td>' +
        '<td colspan="1" class=""><button  ng-disable="ngModel.$viewValue == 1" ng-click="add(-1)" ng-mousedown="minus()" ng-mouseup="stop()" ng-mouseleave="stop()" tabindex="-1" class="btn btn-default summary-red" style="padding: 4px 3px 3px 3px"><i class="icon-exposure_minus_1" style="font-size: 21.5px;"></i><span class="number"></span></button></td>' +
        '</tr>' +
        '<tr>' +
        '<td colspan="2" class=""><button ng-click="reset()" tabindex="-1" class="btn btn-default"><strong>RESET</strong></button></td>' +
        '</tr>' +
        '</div>' +
        '</div>';


    var module = angular.module('tf.qty.directive', ['ui.bootstrap.position'])
        .directive('quantityPicker', ['$timeout', '$interval', '$compile', '$document', '$uibPosition', function ($timeout, $interval, $compile, $document, $uibPosition) {

            return {
                restrict: 'A',
                require: '^ngModel',
                scope : {
                    isStrategy : '=',
                    isStrategyLots : '=',
                    isWhatIfLots : '=',
                    disablePicker: "="
                },
                compile: compile
            };

            function compile(tElem, attrs) {
                return link;
            }

            function link(scope, element, attrs, ngModel) {


                scope = scope.$new();
                scope.show = show;
                scope.hide = hide;
                scope.add = add;
                scope.clear = clear;
                scope.reset = reset;
                scope.set = set;
                scope.swap = swap;
                scope.plus = plus;
                scope.minus = minus;
                scope.stop = stop;
                scope.isBuy = true;
                scope.visible = false;

                var wasTicking = false;
                var ticker = null;
                var tickerDelay = null;

                var hideTimer = null;

                element.addClass('inputNumber');

                var popup = null;

                function createPopup() {
                    if (popup != null) {
                        popup.remove();
                        popup = null;
                    }

                    var templateLinker;
                    if (scope.isStrategy) {
                        templateLinker = $compile(strategyTemplate);
                    } else if (scope.isStrategyLots) {
                        templateLinker = $compile(strategyLotsTemplate);
                    } else if (scope.isWhatIfLots){
                        templateLinker = $compile(whatIfLotsTemplate);
                    } else {
                        templateLinker = $compile(template);
                    }

                    popup = templateLinker(scope, angular.noop);
                    popup[0].addEventListener('focus', focusAndSelectInput, true);

                    $document.find('body').append(popup);
                }

                createPopup();

                var typeWatch = scope.$watch(function () {
                    return scope.isStrategy && scope.isStrategyLots && scope.isWhatIfLots;
                }, createPopup);

                scope.$on("$destroy", function () {
                    typeWatch();
                    if (popup != null) {
                        popup.remove();
                    }
                });

                function possiblyClose(e) {
                    if (e.keyCode === 27) {
                        hide();
                    }
                }

                function focusAndSelectInput() {
                    element.select();
                }

                var isOpen = false;

                function show() {
                    if(isOpen || scope.disablePicker) return;

                    if (hideTimer) {
                        $timeout.cancel(hideTimer);
                        hideTimer = null;
                    }

                    var position = attrs.pickerPosition || 'bottom-left';

                    scope.visible = true;
                    popup[0].style.display = 'block';
                    var ttPosition = $uibPosition.positionElements(element, popup, position, true);

                    if (position.indexOf('bottom') > -1) {
                        popup[0].style.top = (ttPosition.top + 10) + "px";
                    } else {
                        popup[0].style.top = (ttPosition.top - 10)  + "px";
                    }
                    popup[0].style.left = ttPosition.left + "px";

                    isOpen = true;
                }

                function hide() {
                    if(!isOpen) return;

                    if (hideTimer) {
                        $timeout.cancel(hideTimer);
                    }

                    hideTimer = $timeout(function() {
                        popup[0].style.display = 'none';
                        scope.visible = false;
                    }, 0);

                    isOpen = false;
                }

                function plus() {
                    tickerDelay = $timeout(function() {
                        ticker = $interval(up, 200);
                    }, 500);
                }

                function minus() {
                    tickerDelay = $timeout(function() {
                        ticker = $interval(down, 200);
                    }, 500);
                }

                function possiblyTickStart(event) {
                    if (tickerDelay == null) {
                        if (event.keyCode === 38) {
                            event.preventDefault();
                            plus()
                        } else if (event.keyCode === 40) {
                            event.preventDefault();
                            minus();
                        }
                    }
                }

                function possiblyTickStop(event) {
                    if (event.keyCode === 38) {
                        event.preventDefault();
                        stop();
                        if (!wasTicking) {
                            add(1);
                        }
                    } else if (event.keyCode === 40) {
                        event.preventDefault();
                        stop();
                        if (!wasTicking) {
                            add(-1);
                        }
                    }
                }

                function up() {
                    var tmp = 0;
                    if (!ngModel.$isEmpty(ngModel.$viewValue)) {
                        tmp = +ngModel.$viewValue;

                    }

                    if (tmp < 0) {
                        ngModel.$setViewValue(tmp - 1);
                    } else {
                        ngModel.$setViewValue(tmp + 1);
                    }
                    ngModel.$render();
                }

                function down() {
                    var tmp = 0;
                    if (!ngModel.$isEmpty(ngModel.$viewValue)) {
                        tmp = +ngModel.$viewValue;

                    }

                    if (tmp < 0) {
                        ngModel.$setViewValue(tmp + 1);
                    } else {
                        ngModel.$setViewValue(tmp - 1);
                    }
                    ngModel.$render();
                }

                function stop() {
                    if (tickerDelay) {
                        $timeout.cancel(tickerDelay);
                    }
                    tickerDelay = null;

                    wasTicking = ticker != null;
                    if (ticker) {
                        $interval.cancel(ticker);
                    }
                    ticker = null;
                }

                function add(amt) {
                    // Prevent double movement when the ticker was running
                    if (wasTicking) {
                        wasTicking = false;
                        return;
                    }
                    var tmp = 0;
                    if (!ngModel.$isEmpty(ngModel.$viewValue)) {
                        tmp = +ngModel.$viewValue;
                    }

                    if (scope.isBuy) {
                        if (attrs.isWhatIfLots && amt !== 1 && ngModel.$modelValue === 1) {
                            ngModel.$setViewValue(amt);
                        } else {
                            ngModel.$setViewValue(tmp + amt);
                        }
                    } else {
                        if (attrs.isWhatIfLots && amt !== 1 && ngModel.$modelValue === 1) {
                            ngModel.$setViewValue(-amt);
                        } else {
                            ngModel.$setViewValue(tmp - amt);
                        }
                    }
                    ngModel.$render();
                    //ngModel.$commitViewValue();
                    focusAndSelectInput();
                }

                function clear(value) {
                    ngModel.$setViewValue(value || 0);
                    scope.isBuy = true;
                    ngModel.$render();
                    focusAndSelectInput();
                }

                function reset() {
                    ngModel.$setViewValue(1);
                    scope.isBuy = true;
                    ngModel.$render();
                    focusAndSelectInput();
                }

                function set(amt) {
                    ngModel.$setViewValue(amt);
                    if (amt >= 0) {
                        scope.isBuy = true;
                    } else {
                        scope.isBuy = false;
                    }
                    ngModel.$render();
                    focusAndSelectInput();
                }

                function swap() {
                    var tmp = 0;
                    if (!ngModel.$isEmpty(ngModel.$viewValue)) {
                        tmp = +ngModel.$viewValue;
                        ngModel.$setViewValue(-tmp);
                        ngModel.$render();
                    }
                    focusAndSelectInput();
                }

                element.bind('focus', show);
                element.bind('blur', hide);
                element.bind('keydown', possiblyTickStart);
                element.bind('keyup', possiblyTickStop);
                element.bind('keyup', possiblyClose);


                scope.$on('$destroy', function () {
                    element.unbind('focus', show);
                    element.unbind('blur', hide);
                    element.unbind('keydown', possiblyTickStart);
                    element.unbind('keyup', possiblyTickStop);
                    element.unbind('keyup', possiblyClose);
                    popup[0].removeEventListener('focus', focusAndSelectInput);
                    popup.remove();
                });
            }
        }]);
}
